export enum EMLProgramType {
  Unknown = "Unknown",
  SalaryPackaging = "SalaryPackaging",
  Reloadable = "Reloadable",
  InstantGift = "InstantGift",
  PlasticGift = "PlasticGift",
}

export const EMLProgramTypeList = () =>
  Object.entries(EMLProgramType).map(([label, value]) => {
    return { label: value, value: label };
  });
